import React from "react";
import { Link } from "react-router-dom";
import SignInPresenter from "./SignInPresenter";
import { signInUseCase } from "../../usecases/user";
import { Button } from "../../nq-component";
import BasePage from "../../base/BasePage";
import withRouter from "../../withRouter";
import InputFactory from "../../components/InputFactory";

class SignInPage extends BasePage {
  constructor() {
    super();
    this.presenter = new SignInPresenter(this, signInUseCase());
    this.state = { progress: false };
  }

  formSubmit(e) {
    e.preventDefault();
    this.presenter.submit();
  }

  onChange(value, field) {
    this.presenter.onChange(value, field);
  }

  isApplicantWalkIn() {
    return this.props.params.isWalkIn;
  }

  navigateToOptionCards() {
    this.navigateTo("/optioncard");
  }

  render() {
    const master = this.props.params.master === "master";
    const isWalkIn =
      this.props.params.isWalkIn && this.props.params.isWalkIn !== "undefined"
        ? this.props.params.isWalkIn
        : "online";
    return (
      <div className="vh-100">
        <div className="d-flex h-100">
          <div className="m-auto container-md w-100 p-3 p-lg-5 d-flex justify-content-center">
            <div className="bg-white rounded p-3">
              {isWalkIn === "true" ? (
                <div>
                  <button
                    className="text-white btn"
                    style={{ backgroundColor: "#d18237" }}
                    onClick={() => this.navigateToOptionCards()}
                  >
                    <i class="bi bi-arrow-bar-left"></i>Back to Option Card
                  </button>
                </div>
              ) : (
                ""
              )}

              <div className="col-12 col-md-8 col-lg-6 mx-auto">
                <div className="text-center p-3">
                  <img
                    className="img-fluid login-img mb-3"
                    alt="company logo"
                    src="/lgs.jpeg"
                    style={{ maxWidth: "150px", height: "auto" }}
                  />
                </div>

                <div className="p-3 px-lg-5 py-lg-4">
                  <h2
                    className="fw-bold text-center"
                    style={{ color: "#d18237" }}
                  >
                    Login
                  </h2>
                  <p className="text-black-50 text-center mb-4">
                    Enter your details to access your account
                  </p>

                  <form onSubmit={this.formSubmit.bind(this)}>
                    <div className="row g-3">
                      <div className="col-12">
                        {master && (
                          <>
                            <label className="form-label fs-sm">
                              Master key
                            </label>
                            <InputFactory
                              type="Password"
                              required
                              className="form-control bg-light-subtle p-2"
                              placeholder="Master key"
                              field="masterKey"
                              onChange={this.onChange.bind(this)}
                            />
                          </>
                        )}

                        <label className="form-label fs-sm mt-3">Email</label>
                        <InputFactory
                          required
                          type="Email"
                          autoComplete="nope"
                          className="form-control bg-light-subtle p-2"
                          placeholder="Enter your email"
                          field="username"
                          onChange={this.onChange.bind(this)}
                        />
                      </div>

                      <div className="col-12">
                        <label className="form-label fs-sm">Password</label>
                        <InputFactory
                          type="Password"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Enter your password"
                          field="password"
                          onChange={this.onChange.bind(this)}
                        />
                      </div>

                      <div className="text-end">
                        <Link
                          to="/forgot-password"
                          className="fs-sm ms-2 fw-medium"
                          style={{ color: "#d18237" }}
                        >
                          Forgot your password?
                        </Link>
                      </div>

                      <div className="col-12 text-center">
                        <Button
                          progress={this.state.progress}
                          style={{ backgroundColor: "#d18237" }}
                          type="submit"
                          className="btn text-white w-100 fw-bold py-2 fs-6"
                        >
                          {this.state.progress ? "Please wait..." : "Login"}
                        </Button>
                        <div className="my-3 text-black-50">
                          Don't have an account?
                          <Link
                            to={`/signup/${isWalkIn}`}
                            className="ms-1 text-decoration-underline"
                            style={{ color: "#d18237" }}
                          >
                            Sign up
                          </Link>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SignInPage);
